export default __webpack_public_path__ + "2d6ac3ac8554e51ab7f2b325d1f34fbc.svg";